import React from 'react'
import Footer from '../Components/Footer/Footer'
import NavBar from '../Components/NavBar/NavBar'
function Help() {
  return (
    <div>
            <NavBar/>
      <Footer/>
    </div>
  )
}

export default Help
